export default __webpack_public_path__ + "static/media/forestly-expl-dissect-04_DE.bd059f4c.png";